import { createContext, useContext, useMemo } from 'react'

import { ReplayPlaybackControllerContext } from './ReplayPlaybackControllerContext'
import { ReplaySessionContext } from './ReplaySessionContext'

export const ReplayTelemetryFiltererContext = createContext()

export const ReplayTelemetryFiltererProvider = ({ children, events = [] }) => {
  const { currentTime } = useContext(ReplayPlaybackControllerContext)
  const { session } = useContext(ReplaySessionContext)
  const startTime = session?.startTime || 0

  const filteredData = useMemo(() => {
    if (!events.length || !startTime) {
        return { visibleEvents: [], latestEvent: null }
    }

    // Current Absolute Time = Session Start + Scrubber Offset
    const targetTime = startTime + currentTime

    const visibleEvents = events.filter(e => e.timestamp <= targetTime)
    
    // What was the very last thing that happened?
    const latestEvent = visibleEvents.length > 0 ? visibleEvents[visibleEvents.length - 1] : null

    return { visibleEvents, latestEvent }

  }, [currentTime, events, startTime])

  return (
    <ReplayTelemetryFiltererContext.Provider value={filteredData}>
      {children}
    </ReplayTelemetryFiltererContext.Provider>
  )
}